<template>
  <div class="accounts">
    <p class="text-muted" style="margin-top: 20px">
      Banned account domains cannot be added to any ImprovMX account for
      forwarding.
    </p>
    <form @submit.prevent="actionBanDomain">
      <div class="input-group mb-3">
        <input
          type="text"
          placeholder="domain.tld"
          class="form-control"
          v-model="domainToBan"
        />
        <div class="input-group-append">
          <input
            type="submit"
            name="ban"
            value="Ban Domain"
            class="btn btn-sm btn-warning"
          />
        </div>
      </div>
    </form>
    <template v-if="this.total < 0">
      <div class="alert alert-info" role="alert" style="margin-top: 30px">
        Searching...
      </div>
    </template>
    <template v-else-if="this.total > 0">
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">{{ total }} banned domains</h1>
      </div>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Domain</th>
            <th>Added</th>
            <th>Banned by</th>
            <th>Reason</th>
            <th class="text-right">Unban</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="domain in items" v-bind:key="domain.domain">
            <td>{{ domain.domain }}</td>
            <td>{{ domain.added }}</td>
            <td>{{ domain.banned_by }}</td>
            <td>{{ domain.reason }}</td>
            <td class="text-right">
              <a
                href="javascript:;"
                title="Unban this domain"
                class="btn btn-danger"
                v-on:click="unban(domain.domain)"
                >Unban</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <template v-if="$route.query.qs">
        <div class="alert alert-warning" role="alert" style="margin-top: 30px">
          No banned domains found.
        </div>
      </template>
      <template v-else>
        <div class="alert alert-primary" role="alert" style="margin-top: 30px">
          Use the search bar at the top to search for banned domains.
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { formatHttpError } from "../utils/errors";

export default {
  data() {
    return {
      total: -1,
      items: [],
      domainToBan: null,
    };
  },
  created() {
    this.search(true);
  },
  methods: {
    search(redirect) {
      this.$http.get("banneds", { domain: this.$route.query.qs }).then(
        (response) => {
          this.total = response.body.total;
          this.items = response.body.items;
        },
        (response) => {
          if (response.status === 401) return;
          alert(formatHttpError(response));
        },
      );
    },
    unban(domain) {
      this.$http.post(`domains/${domain}/unban`).then(
        () => {
          // Add domain to table and update total banned domains
          const idx = this.items.findIndex((x) => x.domain === domain);
          this.items.splice(idx, 1);
          this.total -= 1;
        },
        (response) => {
          alert(formatHttpError(response));
        },
      );
    },
    async actionBanDomain() {
      let domain = this.domainToBan.trim();
      if (!domain) {
        return;
      }

      domain = domain
        .replace("http://", "")
        .replace("https://", "")
        .replace("/", "");

      const reason = prompt(
        "Please provide a reason for the ban. (Leave blank to cancel)",
      );
      if (!reason) {
        return;
      }
      this.$http.post("domains/" + domain + "/ban", { reason }).then(
        (response) => {
          this.items.unshift({
            domain: domain,
            banned_by: response.body.banned_by,
            reason: response.body.reason,
          });
          this.total += 1;
        },
        (response) => {
          if (response.status === 401) return;
          alert(formatHttpError(response));
        },
      );
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.search(true);
  },
};
</script>
